import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { getData } from 'SRC/common/utils/request';
import { RootState } from 'SRC/views/partner-web/store';
import { setApiUserInfo } from 'SRC/views/partner-web/store/userSlice';
import {
  useAppDispatch,
  useAppSelector,
} from 'SRC/views/partner-web/store/hooks';
import { setPartnerOrgs } from 'SRC/views/partner-web/store/commonSlice';
interface RequireAuthProps {
  children: React.ReactNode;
}
const RouteRequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  // const userStatus = useSelector((state: RootState) => state.user.login_status);
  const loginUser = useAppSelector(
    (state: RootState) => state.user.apiUserInfo
  );

  useEffect(() => {
    if (loginUser.status == 'login') {
      // navigate('/index');
    } else {
      getData('/api/users/info/').then((res: any) => {
        if (res.data?.status === 'logout') {
          dispatch(setApiUserInfo({ status: 'logout' }));
          navigate('/login');
        } else if (res.data?.status === 'login') {
          dispatch(setApiUserInfo(res.data));
          // setTimeout(() => {
          //   navigate('/index');
          // }, 500);
          getData('/api/exercise/partner/orgs/').then((resp: any) => {
            const partnerlist = resp.data;
            dispatch(setPartnerOrgs(partnerlist));
          });
        }
      });
    }
  }, [loginUser.status]);

  // useEffect(() => {
  //   if (!loading && !(loginUser.status == 'login')) {
  //     // 重定向到/about
  //     navigate('/login');
  //   } else {
  //     navigate('/index');
  //   }
  // }, [loginUser, loading]);

  return <>{children}</>;
};

export default RouteRequireAuth;
